import { addDefaultAction } from './popup-message';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { showAutoCloseMessageDialog } from '../components/auto-close-message-popup';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';

export const showAutoCloseOnCashDrawerCloseMessage = (message: IMessageModal) => {
  addDefaultAction(message, popEmeraldModal);
  showAutoCloseMessageDialog({ ...message, autoCloseWithCashRegister: true });
};
